// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/solana-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NativeBalanceChange
 */
export interface NativeBalanceChange {
    /**
     * 
     * @type {string}
     * @memberof NativeBalanceChange
     */
    account: string;
    /**
     * 
     * @type {number}
     * @memberof NativeBalanceChange
     */
    amount: number;
}

/**
 * Check if a given object implements the NativeBalanceChange interface.
 */
export function instanceOfNativeBalanceChange(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "account" in value;
    isInstance = isInstance && "amount" in value;

    return isInstance;
}

export function NativeBalanceChangeFromJSON(json: any): NativeBalanceChange {
    return NativeBalanceChangeFromJSONTyped(json, false);
}

export function NativeBalanceChangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): NativeBalanceChange {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'account': json['account'],
        'amount': json['amount'],
    };
}

export function NativeBalanceChangeToJSON(value?: NativeBalanceChange | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account': value.account,
        'amount': value.amount,
    };
}

